<div class="container">
  <div
    class="error-layout__container"
    [ngClass]="{ 'error-layout__validate-identity': error_identity }"
  >
    <ng-content></ng-content>
  </div>
</div>
